import rip from "refractor/rip";
export default rip;